<div *ngIf="isValidProfile" class="invalid-profile-modal-wrap">
  <div class="invalid-profile-modal">
    <p class="title">会員の皆様へお願い</p>
    <p class="text">
      この度、会員情報につきまして一部の項目を登録必須といたしましたので、登録のご協力をお願いいたします。
    </p>
    <div class="btn-wrap">
      <button type="button" class="btn btn-reset" (click)="close()">閉じる</button>
      <button type="button" class="btn btn-primary" (click)="submit()">会員情報を登録する</button>
    </div>
    <div class="img-container">
      <img src="assets/img/logo_color.png" class="logo" />
    </div>
  </div>
</div>
